/* Phase 8.1 — Archive Book section runtime.
   Spec: docs/superpowers/specs/2026-05-29-archive-book-design.md
   Plan: docs/superpowers/plans/2026-05-29-phase-8-1-archive-book.md */
(function () {
  'use strict';

  var root = document.querySelector('[data-arch-book]');
  if (!root) return;

  var book = root.querySelector('[data-arch-book-stage]');
  if (!book) return;

  var chapters = Array.prototype.slice.call(book.querySelectorAll('.arch-book__chapter'));
  if (!chapters.length) return;

  var turningPage = book.querySelector('[data-turning-page]');
  var turningFront = book.querySelector('[data-turning-front]');
  var turningBack  = book.querySelector('[data-turning-back]');
  var seal = book.querySelector('[data-arch-seal]');
  var bookmark = root.querySelector('[data-bookmark]');
  var bookmarkNum = root.querySelector('[data-bookmark-num]');
  var bookmarkTitle = root.querySelector('[data-bookmark-title]');
  var bookmarkEra = root.querySelector('[data-bookmark-era]');
  var bookmarkCta = root.querySelector('[data-bookmark-cta]');
  var bookmarkBack = root.querySelector('[data-bookmark-back]');
  var bookmarkPageNo = root.querySelector('[data-bookmark-pageno]');
  var srAnnounce = root.querySelector('[data-sr-announce]');

  var topStripButtons = Array.prototype.slice.call(root.querySelectorAll('.arch-book__strip--top button[data-chapter-index]'));
  var bottomStripButtons = Array.prototype.slice.call(root.querySelectorAll('.arch-book__strip--bottom button[data-chapter-index]'));
  var notifyButtons = Array.prototype.slice.call(root.querySelectorAll('[data-arch-notify]'));

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // GSAP loads as a separate deferred <script> tag. Defer scripts execute in DOM
  // order — if our IIFE runs before GSAP's script, a cached typeof check at this
  // point would forever read 'undefined'. Check it at call time instead.
  function hasGSAP() { return typeof window.gsap !== 'undefined' && typeof window.gsap.timeline === 'function'; }
  var ANIM_MS = 450;
  var animating = false;
  var currentIndex = 0;
  var currentPage = 'left';
  var currentPageIndex = 0; // 0 = cover spread; 1..N = interior pages
  var activeTimeline = null;

  function interiorPages(i) {
    var ch = chapters[i];
    if (!ch) return [];
    return Array.prototype.slice.call(ch.querySelectorAll('[data-interior-page]'));
  }
  function lastInteriorIndex(i) {
    // interior pages are 1-based; returns the highest page index, or 0 if none.
    return interiorPages(i).length;
  }
  function setActivePageIndex(n) {
    currentPageIndex = n;
    book.setAttribute('data-active-page-index', String(n));
    // toggle which interior page is visible
    interiorPages(currentIndex).forEach(function (p) {
      var pageNo = parseInt(p.getAttribute('data-interior-page'), 10);
      if (pageNo === n) p.setAttribute('data-interior-active', 'true');
      else p.removeAttribute('data-interior-active');
    });
    updateBookmarkMode();
  }
  function updateBookmarkMode() {
    if (bookmark) {
      var last = lastInteriorIndex(currentIndex);
      if (last > 0 && currentPageIndex > 0 && currentPageIndex < last) {
        // Reading interior pages (not last): page scroller.
        bookmark.setAttribute('data-mode', 'page');
        // Show the page the scroller will turn TO (currentPageIndex + 1) of last.
        if (bookmarkPageNo) bookmarkPageNo.textContent = (currentPageIndex + 1) + ' / ' + last;
      } else if (last > 0 && currentPageIndex === last) {
        // On the last interior page: continue to the story section.
        bookmark.setAttribute('data-mode', 'final');
      } else if (last > 0 && currentPageIndex === 0) {
        // Cover of an image/interior chapter: first forward turn is a page turn.
        bookmark.setAttribute('data-mode', 'page');
        if (bookmarkPageNo) bookmarkPageNo.textContent = '1 / ' + last;
      } else {
        // Standard chapter (no interior pages): next-chapter card.
        bookmark.setAttribute('data-mode', 'chapter');
      }
    }
    // Back control is available whenever there's a previous page or chapter.
    if (bookmarkBack) {
      var canBack = (currentPageIndex > 0) || (currentIndex > 0);
      if (canBack) bookmarkBack.setAttribute('data-can-go-back', 'true');
      else bookmarkBack.removeAttribute('data-can-go-back');
    }
  }

  function chapterMeta(i) {
    var ch = chapters[i];
    return {
      el: ch,
      status: ch.getAttribute('data-status'),
      handle: ch.getAttribute('data-era-handle') || '',
      name: ch.getAttribute('data-era-name') || ''
    };
  }

  function updateAriaCurrent() {
    topStripButtons.concat(bottomStripButtons).forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-chapter-index'), 10);
      if (idx === currentIndex) {
        btn.setAttribute('aria-current', 'true');
        btn.classList.add('arch-book__strip-card--active');
      } else {
        btn.removeAttribute('aria-current');
        btn.classList.remove('arch-book__strip-card--active');
      }
    });
  }

  var soonChapterEl = root.querySelector('[data-soon-chapter]');
  function updateSealVisibility() {
    var meta = chapterMeta(currentIndex);
    book.setAttribute('data-active-status', meta.status);
    // Name the coming-soon chapter in its overlay eyebrow.
    if (soonChapterEl && meta.status === 'coming-soon') {
      soonChapterEl.textContent = meta.name || '';
    }
  }

  function updateBookmark() {
    if (!bookmark) return;
    var nextIdx = currentIndex + 1;
    if (nextIdx >= chapters.length) {
      bookmark.setAttribute('data-hidden', 'true');
      return;
    }
    bookmark.removeAttribute('data-hidden');
    var nextCh = chapters[nextIdx];
    var stripBtn = topStripButtons[nextIdx];
    var num = stripBtn ? stripBtn.textContent.trim() : '';
    if (bookmarkNum) bookmarkNum.textContent = num;
    if (bookmarkTitle) bookmarkTitle.textContent = nextCh.getAttribute('data-era-name') || '';
    if (bookmarkEra) {
      var subtitleEl = nextCh.querySelector('.arch-book__era-subtitle');
      bookmarkEra.textContent = subtitleEl ? subtitleEl.textContent.split('·')[0].trim() : '';
    }
  }

  function announce(text) {
    if (srAnnounce) srAnnounce.textContent = text;
  }

  function fireDataLayer(payload) {
    if (typeof window.dataLayer !== 'undefined' && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }
  }

  function swapActiveChapter(idx, source) {
    // DOM/aria/bookmark/announce/analytics — safe to run mid-flight. Does NOT
    // toggle the wax-seal CSS, because the seal is a visual reveal that should
    // land with the new page, not pop in during the rotation. See revealActiveState.
    chapters.forEach(function (ch, i) {
      var isActive = (i === idx);
      ch.classList.toggle('arch-book__chapter--active', isActive);
      if (isActive) ch.removeAttribute('aria-hidden');
      else ch.setAttribute('aria-hidden', 'true');
    });
    currentIndex = idx;
    // Leaving/entering a chapter always resets to its cover spread.
    currentPageIndex = 0;
    book.setAttribute('data-active-page-index', '0');
    interiorPages(idx).forEach(function (p) { p.removeAttribute('data-interior-active'); });
    book.setAttribute('data-active-chapter', String(idx));
    updateAriaCurrent();
    updateBookmark();
    var meta = chapterMeta(idx);
    announce('Now reading: Chapter ' + meta.name);
    fireDataLayer({ event: 'archive_chapter_view', chapter: meta.handle, source: source || 'init' });
    updateBookmarkMode();
  }

  function revealActiveState() {
    // Visual-only: flips [data-active-status] which the CSS keys on to show/hide
    // the wax-seal overlay. Called from turn onComplete and from the non-animation
    // setActiveChapter path so the seal never appears mid-rotation.
    updateSealVisibility();
  }

  function setActiveChapter(idx, source) {
    swapActiveChapter(idx, source);
    revealActiveState();
    mountFlipIsland(0);
  }

  function clearTurningFaces() {
    [turningFront, turningBack].forEach(function (face) {
      if (!face) return;
      face.innerHTML = '';
      face.classList.remove('arch-book__turning-face--spread', 'arch-book__turning-face--content');
      face.removeAttribute('data-turning-side');
      face.style.backgroundImage = '';
    });
    if (turningPage) turningPage.removeAttribute('data-turn-direction');
  }

  function interiorPage(i, pageNo) {
    var pages = interiorPages(i);
    for (var k = 0; k < pages.length; k++) {
      if (parseInt(pages[k].getAttribute('data-interior-page'), 10) === pageNo) {
        return pages[k];
      }
    }
    return null;
  }

  function spreadImage(i, pageNo) {
    var ch = chapters[i];
    if (!ch) return null;
    if (pageNo === 0) return ch.querySelector('.arch-book__base--override');
    var page = interiorPage(i, pageNo);
    return page ? page.querySelector('.arch-book__interior-img') : null;
  }

  function renderTurningFace(face, chapterIndex, pageNo, side) {
    if (!face) return;

    var image = spreadImage(chapterIndex, pageNo);
    var imageSrc = image && (image.currentSrc || image.getAttribute('src'));
    if (imageSrc) {
      // Full-spread artwork must be cropped to one physical page. Inserting the
      // <img> directly compresses the entire open book into this 36%-wide leaf.
      face.classList.add('arch-book__turning-face--spread');
      face.setAttribute('data-turning-side', side);
      face.style.backgroundImage = 'url("' + encodeURI(imageSrc).replace(/"/g, '%22') + '")';
      return;
    }

    var ch = chapters[chapterIndex];
    var source = null;
    if (ch && pageNo === 0) {
      source = ch.querySelector('.arch-book__page--' + side);
    } else if (side === 'left') {
      var page = interiorPage(chapterIndex, pageNo);
      source = page && (page.querySelector('.arch-book__interior-inner') || page);
    }

    face.classList.add('arch-book__turning-face--content');
    if (source) face.innerHTML = source.innerHTML;
  }

  function prepareTurningFaces(outgoingChapter, outgoingPage, incomingChapter, incomingPage, direction) {
    var frontSide = direction === 1 ? 'right' : 'left';
    var backSide = direction === 1 ? 'left' : 'right';
    clearTurningFaces();
    turningPage.setAttribute('data-turn-direction', direction === 1 ? 'forward' : 'backward');
    turningPage.style.transformOrigin = direction === 1 ? 'left center' : 'right center';
    renderTurningFace(turningFront, outgoingChapter, outgoingPage, frontSide);
    renderTurningFace(turningBack, incomingChapter, incomingPage, backSide);
  }

  function killTimeline() {
    // NOTE: intentionally does NOT roll back currentIndex / currentPageIndex or
    // the data-active-* attributes. Page/chapter state is committed only at the
    // timeline's 0.20 midpoint (via swapActiveChapter / setActivePageIndex), so
    // an interrupted turn always leaves state on the last committed value — there
    // is nothing to roll back. Do not pre-set data-active-page-index at turn start.
    if (activeTimeline && typeof activeTimeline.kill === 'function') {
      activeTimeline.kill();
    }
    if (turningPage) {
      turningPage.style.opacity = '';
      turningPage.style.transform = '';
    }
    clearTurningFaces();
    animating = false;
    // An aborted turn never reaches onComplete — restore the island for the
    // committed chapter/page state (no-op on non-image chapters).
    mountFlipIsland(currentPageIndex);
  }

  function turnTo(targetIdx, source) {
    if (animating) killTimeline();
    if (targetIdx < 0 || targetIdx >= chapters.length) return;
    if (targetIdx === currentIndex) return;
    suspendFlipIsland();

    if (prefersReducedMotion || !hasGSAP() || !turningPage) {
      setActiveChapter(targetIdx, source);
      return;
    }

    animating = true;
    var direction = (targetIdx > currentIndex) ? 1 : -1;
    var rotateMid = (direction === 1) ? -90 : 90;
    var rotateEnd = (direction === 1) ? -180 : 180;

    prepareTurningFaces(currentIndex, 0, targetIdx, 0, direction);

    var tl = window.gsap.timeline({
      onComplete: function () {
        animating = false;
        turningPage.style.opacity = '0';
        turningPage.style.transform = '';
        clearTurningFaces();
        // Reveal wax-seal NOW (not at mid-flight) so it lands cleanly with the page.
        revealActiveState();
        mountFlipIsland(0);
      }
    });
    activeTimeline = tl;

    tl.set(turningPage, { rotateY: 0, z: 0, opacity: 0 });
    tl.to(turningPage, { opacity: 1, duration: 0.05 }, 0);
    tl.to(turningPage, { rotateY: rotateMid, z: 20, duration: 0.20, ease: 'power2.in' }, 0);

    // Mid-flight: swap underlying chapter DOM but NOT the seal — seal reveal waits for onComplete.
    tl.call(function () { swapActiveChapter(targetIdx, source); }, [], 0.20);

    tl.to(turningPage, { rotateY: rotateEnd, z: 0, duration: 0.25, ease: 'power2.out' }, 0.20);
  }

  function turnInterior(target, source) {
    var last = lastInteriorIndex(currentIndex);
    if (target < 0 || target > last) return;
    if (target === currentPageIndex) return;
    if (animating) killTimeline();

    if (islandActive()) {
      flipIsland.pendingSource = source || 'flip';
      var delta = target - currentPageIndex;
      if (delta === 1) flipIsland.instance.flipNext('top');
      else if (delta === -1) flipIsland.instance.flipPrev('top');
      else {
        flipIsland.instance.turnToPage(target * 2);
        commitIslandPage(target); // out-of-range turnToPage emits nothing; commit directly (guard dedupes)
      }
      return;
    }

    // Announce + analytics for landing on an interior page. `source` is the
    // originating input (keyboard / bookmark / swipe) for the dataLayer event,
    // matching the chapter-level archive_chapter_view instrumentation.
    function commitInteriorPage(pageNo) {
      setActivePageIndex(pageNo);
      announce('Page ' + pageNo + ' of ' + last);
      fireDataLayer({ event: 'archive_page_view', chapter: chapterMeta(currentIndex).handle, page: pageNo, source: source || 'nav' });
    }

    if (prefersReducedMotion || !hasGSAP() || !turningPage) {
      commitInteriorPage(target);
      return;
    }

    animating = true;
    var direction = (target > currentPageIndex) ? 1 : -1;
    var rotateMid = (direction === 1) ? -90 : 90;
    var rotateEnd = (direction === 1) ? -180 : 180;

    prepareTurningFaces(currentIndex, currentPageIndex, currentIndex, target, direction);

    var tl = window.gsap.timeline({
      onComplete: function () {
        animating = false;
        turningPage.style.opacity = '0';
        turningPage.style.transform = '';
        clearTurningFaces();
      }
    });
    activeTimeline = tl;
    tl.set(turningPage, { rotateY: 0, z: 0, opacity: 0 });
    tl.to(turningPage, { opacity: 1, duration: 0.05 }, 0);
    tl.to(turningPage, { rotateY: rotateMid, z: 20, duration: 0.20, ease: 'power2.in' }, 0);
    tl.call(function () { commitInteriorPage(target); }, [], 0.20);
    tl.to(turningPage, { rotateY: rotateEnd, z: 0, duration: 0.25, ease: 'power2.out' }, 0.20);
  }

  function exitBookToStory() {
    fireDataLayer({ event: 'archive_book_completed', chapter: chapterMeta(currentIndex).handle });
    var story = document.querySelector('#chapter-0-story');
    if (story && typeof story.scrollIntoView === 'function') {
      story.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
    }
    // If no story section present, stay on the final page (no-op).
  }

  function goForward(source) {
    var last = lastInteriorIndex(currentIndex);
    if (last > 0 && currentPageIndex < last) {
      turnInterior(currentPageIndex + 1, source);
    } else if (last > 0 && currentPageIndex === last) {
      exitBookToStory();
    } else {
      turnTo(currentIndex + 1, source);
    }
  }
  function goBackward(source) {
    if (currentPageIndex > 0) {
      turnInterior(currentPageIndex - 1, source);
    } else {
      turnTo(currentIndex - 1, source);
    }
  }

  function setActivePage(side) {
    currentPage = side;
    book.setAttribute('data-active-page', side);
  }

  function advanceMobile(direction) {
    var last = lastInteriorIndex(currentIndex);
    if (direction === 1) {
      if (last > 0 && currentPageIndex < last) { turnInterior(currentPageIndex + 1, 'swipe'); return; }
      if (last > 0 && currentPageIndex === last) { exitBookToStory(); return; }
      if (currentPage === 'left') { setActivePage('right'); }
      else if (currentIndex < chapters.length - 1) { setActivePage('left'); turnTo(currentIndex + 1, 'swipe'); }
    } else {
      if (currentPageIndex > 0) { turnInterior(currentPageIndex - 1, 'swipe'); return; }
      if (currentPage === 'right') { setActivePage('left'); }
      else if (currentIndex > 0) { setActivePage('right'); turnTo(currentIndex - 1, 'swipe'); }
    }
  }

  /* ---------- StPageFlip reading-flow island (2026-08 graft) ---------- */
  // Corner-drag page physics for image-pages chapters. The island owns the
  // reading-flow visuals + input; state stays in this engine via
  // commitIslandPage -> setActivePageIndex, so bookmark modes, analytics,
  // deep links and announcements behave exactly as the legacy path.
  //
  // Lifecycle: the StPageFlip instance is built ONCE per chapter and then
  // suspended/resumed across chapter turns instead of destroyed — the
  // library's destroy() cannot stop its internal rAF render loop, so
  // re-creating per turn would leak a running loop each time.
  //
  // Desktop-only: below 768px the stage switches to a portrait 3:4 layout the
  // island geometry isn't calibrated for (and the library forces an inline
  // min-width that overflows it), so phones keep the legacy reading path.
  var flipIsland = { instance: null, container: null, chapterIndex: -1, pendingSource: null, suspended: false };
  var flipDesktopMq = window.matchMedia('(min-width: 768px)');

  // St loads as its own deferred <script>; never cache this check (same trap
  // as hasGSAP above).
  function hasSt() { return typeof window.St !== 'undefined' && typeof window.St.PageFlip === 'function'; }
  function islandActive() { return flipIsland.instance !== null && !flipIsland.suspended; }

  function chapterSpreadSources(i) {
    // Spread 0 = the chapter's own base art; spreads 1..N = interior page imgs.
    var ch = chapters[i];
    if (!ch) return [];
    var base = ch.querySelector('.arch-book__base--override');
    if (!base) return [];
    var srcs = [base.currentSrc || base.getAttribute('src')];
    interiorPages(i).forEach(function (p) {
      var img = p.querySelector('.arch-book__interior-img');
      if (img) srcs.push(img.currentSrc || img.getAttribute('src'));
    });
    return srcs;
  }

  function commitIslandPage(spread) {
    if (spread === currentPageIndex) return;
    var src = flipIsland.pendingSource || 'flip';
    flipIsland.pendingSource = null;
    setActivePageIndex(spread);
    announce('Page ' + spread + ' of ' + lastInteriorIndex(currentIndex));
    fireDataLayer({ event: 'archive_page_view', chapter: chapterMeta(currentIndex).handle, page: spread, source: src });
  }

  function suspendFlipIsland() {
    // Hide (don't destroy) for chapter turns — see lifecycle note above.
    if (!flipIsland.instance || flipIsland.suspended) return;
    flipIsland.container.setAttribute('hidden', '');
    var ch = chapters[flipIsland.chapterIndex];
    if (ch) {
      var override = ch.querySelector('.arch-book__base--override');
      if (override) override.removeAttribute('data-flip-hidden');
    }
    book.removeAttribute('data-flip-active');
    flipIsland.suspended = true;
    // Flush any in-flight drag/flip so its completion event fires NOW, while
    // the guard above drops it (suspended), instead of ~900ms later.
    if (typeof flipIsland.instance.getRender === 'function') {
      try { flipIsland.instance.getRender().finishAnimation(); } catch (err) { /* best effort */ }
    }
    flipIsland.pendingSource = null;
  }

  function destroyFlipIsland() {
    // Full teardown — only for a failed build or a chapter mismatch.
    if (!flipIsland.instance) return;
    if (typeof flipIsland.instance.destroy === 'function') {
      try { flipIsland.instance.destroy(); } catch (err) { /* best-effort teardown */ }
    }
    if (flipIsland.container && flipIsland.container.parentNode) {
      flipIsland.container.parentNode.removeChild(flipIsland.container);
    }
    var ch = chapters[flipIsland.chapterIndex];
    if (ch) {
      var override = ch.querySelector('.arch-book__base--override');
      if (override) override.removeAttribute('data-flip-hidden');
    }
    book.removeAttribute('data-flip-active');
    flipIsland.instance = null;
    flipIsland.container = null;
    flipIsland.chapterIndex = -1;
    flipIsland.pendingSource = null;
    flipIsland.suspended = false;
  }

  function mountFlipIsland(startPage) {
    var ch = chapters[currentIndex];
    var eligible = !!ch && ch.classList.contains('arch-book__chapter--image-pages') &&
      !prefersReducedMotion && hasSt() && flipDesktopMq.matches;
    var srcs = eligible ? chapterSpreadSources(currentIndex) : [];
    // need cover + >=1 interior page, and the spread list must match the
    // engine's page count (a text/image mixed chapter falls back to legacy)
    if (!eligible || srcs.length < 2 || srcs.length - 1 !== lastInteriorIndex(currentIndex)) {
      // Reconcile: a live island must never stay active for a chapter (or
      // viewport) that can't host one.
      if (islandActive()) suspendFlipIsland();
      return false;
    }

    var page = (typeof startPage === 'number' && startPage > 0) ? startPage : 0;

    if (flipIsland.instance && flipIsland.chapterIndex === currentIndex) {
      // Resume the cached instance.
      flipIsland.container.removeAttribute('hidden');
      flipIsland.suspended = false;
      var overrideResume = ch.querySelector('.arch-book__base--override');
      if (overrideResume) overrideResume.setAttribute('data-flip-hidden', 'true');
      book.setAttribute('data-flip-active', 'true');
      // In-range turnToPage always emits 'flip'; commitIslandPage's guard
      // makes the same-spread case a no-op.
      flipIsland.instance.turnToPage(page * 2);
      return true;
    }
    if (flipIsland.instance) destroyFlipIsland(); // cached for a different chapter (not reachable today)

    var container = document.createElement('div');
    container.className = 'arch-book__flip';
    var flipEl = document.createElement('div');
    flipEl.className = 'arch-book__flip-book';
    container.appendChild(flipEl);

    var leaves = [];
    srcs.forEach(function (src) {
      ['left', 'right'].forEach(function (side) {
        var leaf = document.createElement('div');
        leaf.className = 'arch-book__flip-leaf arch-book__flip-leaf--' + side;
        leaf.setAttribute('data-density', 'soft');
        var art = document.createElement('div');
        art.className = 'arch-book__flip-art arch-book__flip-art--' + side;
        art.style.backgroundImage = 'url("' + String(src).replace(/"/g, '%22') + '")';
        leaf.appendChild(art);
        flipEl.appendChild(leaf);
        leaves.push(leaf);
      });
    });

    ch.appendChild(container);

    var pf;
    try {
      pf = new window.St.PageFlip(flipEl, {
        width: 560, height: 718, size: 'stretch',
        minWidth: 240, maxWidth: 560, minHeight: 308, maxHeight: 718,
        autoSize: false, showCover: false, usePortrait: false,
        drawShadow: true, maxShadowOpacity: 0.38,
        flippingTime: 920,
        useMouseEvents: true,
        mobileScrollSupport: true,
        swipeDistance: 24, showPageCorners: true, disableFlipByClick: false
      });
      pf.loadFromHTML(leaves);
    } catch (err) {
      if (container.parentNode) container.parentNode.removeChild(container);
      return false;
    }

    flipIsland.instance = pf;
    flipIsland.container = container;
    flipIsland.chapterIndex = currentIndex;
    flipIsland.suspended = false;

    var override = ch.querySelector('.arch-book__base--override');
    if (override) override.setAttribute('data-flip-hidden', 'true');
    book.setAttribute('data-flip-active', 'true');

    pf.on('flip', function (e) {
      if (flipIsland.instance !== pf || !islandActive()) return; // stale or suspended island
      commitIslandPage(Math.floor((e.data || 0) / 2));
    });

    if (page > 0) {
      pf.turnToPage(page * 2);
      commitIslandPage(page); // belt: guard makes this a no-op if the event landed
    }
    return true;
  }

  // Crossing the desktop/mobile boundary mounts or suspends the island live
  // (e.g. tablet rotation across 768px).
  if (typeof flipDesktopMq.addEventListener === 'function') {
    flipDesktopMq.addEventListener('change', function (e) {
      if (e.matches) { if (!islandActive()) mountFlipIsland(currentPageIndex); }
      else if (islandActive()) suspendFlipIsland();
    });
  }

  /* ---------- Click handlers ---------- */
  topStripButtons.concat(bottomStripButtons).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(btn.getAttribute('data-chapter-index'), 10);
      if (!isNaN(idx)) turnTo(idx, 'strip');
    });
  });

  if (bookmarkCta) {
    bookmarkCta.addEventListener('click', function () {
      goForward('bookmark');
    });
  }

  if (bookmarkBack) {
    bookmarkBack.addEventListener('click', function () {
      goBackward('back-button');
    });
  }

  /* ---------- Keyboard ---------- */
  root.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { goForward('keyboard'); }
    else if (e.key === 'ArrowLeft') { goBackward('keyboard'); }
  });

  /* ---------- Touch / swipe ---------- */
  (function setupTouch() {
    var stage = root.querySelector('.arch-book__stage');
    if (!stage) return;
    var startX = 0, startY = 0, tracking = false;
    var THRESHOLD = 40;
    // EDGE_GUARD reserves the left/right ~30px for iOS Safari edge-swipe-back gesture.
    // Below 30 risks gesture conflicts on iPhones; well above 40 over-rejects legitimate swipes.
    var EDGE_GUARD = 30;

    stage.addEventListener('touchstart', function (e) {
      if (animating) return;
      var t = e.touches[0];
      if (t.clientX < EDGE_GUARD || t.clientX > (window.innerWidth - EDGE_GUARD)) return;
      startX = t.clientX; startY = t.clientY; tracking = true;
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      if (!tracking) return;
      var t = e.touches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (Math.abs(dx) < Math.abs(dy)) { tracking = false; return; }
    }, { passive: true });

    stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX;
      if (islandActive()) {
        // StPageFlip owns in-flow touch turns; only the final-page forward
        // swipe still belongs to the engine (continue to the story section).
        var lastPg = lastInteriorIndex(currentIndex);
        if (Math.abs(dx) >= THRESHOLD && dx < 0 && lastPg > 0 && currentPageIndex === lastPg) {
          exitBookToStory();
        }
        return;
      }
      if (Math.abs(dx) < THRESHOLD) return;
      advanceMobile(dx < 0 ? 1 : -1);
    }, { passive: true });
  })();

  /* ---------- Notify-me CTAs → Phase 6.14 capture modal ---------- */
  notifyButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var slug, name;
      if (btn.hasAttribute('data-seal-cta')) {
        var meta = chapterMeta(currentIndex);
        slug = meta.handle;
        name = meta.name;
      } else {
        slug = btn.getAttribute('data-era-slug') || '';
        name = btn.getAttribute('data-era-name') || '';
      }
      fireDataLayer({ event: 'archive_notify_me_clicked', chapter: slug, status: chapterMeta(currentIndex).status });
      if (typeof window.iLiveOpenChapterModal === 'function') {
        window.iLiveOpenChapterModal(slug, name);
      }
    });
  });

  /* ---------- Open chapter CTA analytics ---------- */
  Array.prototype.slice.call(root.querySelectorAll('a.arch-book__cta--open')).forEach(function (a) {
    a.addEventListener('click', function () {
      var meta = chapterMeta(currentIndex);
      fireDataLayer({ event: 'archive_cta_clicked', chapter: meta.handle, cta_url: a.getAttribute('href') });
    });
  });

  /* ---------- Deep-link ?chapter=<handle> ---------- */
  (function deepLink() {
    try {
      var params = new URLSearchParams(window.location.search);
      var handle = params.get('chapter');
      if (!handle) return;
      for (var i = 0; i < chapters.length; i++) {
        if (chapters[i].getAttribute('data-era-handle') === handle) {
          setActiveChapter(i, 'deeplink');
          var pageParam = parseInt(params.get('page'), 10);
          if (!isNaN(pageParam) && pageParam > 0 && pageParam <= lastInteriorIndex(i)) {
            setActivePageIndex(pageParam);
            if (islandActive()) flipIsland.instance.turnToPage(pageParam * 2);
          }
          break;
        }
      }
    } catch (err) { /* URLSearchParams missing or malformed query — bail silently */ }
  })();

  /* ---------- Initial state ---------- */
  updateAriaCurrent();
  updateSealVisibility();
  updateBookmark();
  // The deep-link IIFE above may already have turned to a page — stamp the
  // real state, not 0, or deep-linked loads render the cover with a page-N
  // bookmark (currentPageIndex is 0 on normal loads).
  book.setAttribute('data-active-page-index', String(currentPageIndex));
  updateBookmarkMode();

  // Deep-linked loads already mounted via setActiveChapter — don't remount.
  if (!islandActive() && !mountFlipIsland(currentPageIndex)) {
    // St's deferred script may not have executed yet (or a CDN hiccup);
    // retry once after full load, else the legacy instant-swap path stands.
    window.addEventListener('load', function () {
      if (!islandActive()) mountFlipIsland(currentPageIndex);
    }, { once: true });
  }
})();
